import { init } from '@clientis/clientis-banking-theme/src/ts/init';
import { IOptions } from '@clientis/clientis-banking-theme/src/ts/interfaces/initOptions';
import { initDisclaimer } from './eks/disclaimer';
import { initWidgets } from '@clientis/clientis-banking-theme/src/ts/widget/widget';
import { CONFIG } from './widget/variables';
import { searchHighlighter } from './eks/searchHighlighter';

const options: IOptions = {
  allPortletsReady: {
    afterAll: [initDisclaimer],
  },
};

init(options);

// on document load call initWidgets
onload = () => {
  initWidgets(CONFIG);
  searchHighlighter.init();
};
